import { cx } from 'utils/cx'
import styles from './Badge.module.scss'

export enum Status {
	Alert = 'alert',
	Default = 'default',
	Info = 'info',
	Success = 'success',
	Warning = 'warning',
}

type BadgeProps = {
	readonly status?: Status
	readonly className?: string
}

export const Badge = ({ status = Status.Default, className }: BadgeProps) => (
	<div
		className={cx(styles.badge, styles[status], className)}
		data-testid='badge'
	/>
)
